const localization = {
  nl: {
    locationTitle: 'Locatie',
    locationText: 'Gelegen in Kopp (DE), een dorpje midden in de prachtige Vulkaneifel',
    locationLink: 'Routebeschrijving',
    locationTarget: '/omgeving',
    featuresTitle: 'Kenmerken',
    featuresText: '9 Slaapkamers met ieder een eigen douche, toilet en wastafel',
    featuresLink: 'Bekijk alle kenmerken',
    featuresTarget: '/hethuis',
    bookTitle: 'Boek online',
    bookLink: 'Prik uw datums en boek vandaag nog via Micazu',
  },
  de: {
    locationTitle: 'Lage',
    locationText: 'Das Haus liegt in Kopp, einem Dorf in der Mitte der schönen Vulkaneifel',
    locationLink: 'Wegbeschreibung',
    locationTarget: '/dieumgebung',
    featuresTitle: 'Eigenschaften',
    featuresText: '9 Slafzimmer mit jeweils eigener Dusche, Toilette und Washbecken',
    featuresLink: 'Alle Eigenschaften anzeigen',
    featuresTarget: '/dashaus',
    bookTitle: 'Online buchen',
    bookLink: 'Wählen Sie Ihre Daten und buchen Sie noch heute mit Micazu',
  },
  en: {
    locationTitle: 'Location',
    locationText: 'Located in Kopp (DE), a village in the middle of the beautiful Vulkaneifel',
    locationLink: 'Directions',
    locationTarget: '/dieumgebung',
    featuresTitle: 'Features',
    featuresText: '9 Bedrooms each with their own shower, toilet and sink',
    featuresLink: 'View all features',
    featuresTarget: '/thehouse',
    bookTitle: 'Book online',
    bookLink: 'Pick your dates and book today through Micazu',
  },
}

export default localization



// WEBPACK FOOTER //
// ./src/components/PageHome/Badges/localization.js